import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { FC, ReactNode } from "react";

/**
 * Value with a muted note in front of it, e.g. "5h 49m ≈ 6h" or "€14 x 13% = €1.82"
 * - the note sits on the left so the values of a right-aligned column stay under each other
 * - on a narrow cell the note shrinks with an ellipsis, the value never wraps
 * - the value inherits the cell's text so it matches the other columns, the note is one step smaller and muted
 *   (body2 is the smaller variant in our theme, caption is larger than the table text)
 */
export const NotedValue: FC<{
  note?: string | null;
  noteTitle?: string;
  children: ReactNode;
}> = ({ note, noteTitle, children }) => (
  <Stack alignItems="baseline" direction="row" justifyContent="flex-end" spacing={0.5} sx={{ minWidth: 0, width: "100%" }}>
    {note && (
      <Typography color="text.secondary" component="span" noWrap title={noteTitle} variant="body2">
        {note}
      </Typography>
    )}
    <Box component="span" sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
      {children}
    </Box>
  </Stack>
);
